import { SourceType } from 'module/api/filter/types';
import { asUserMetaData } from 'module/helpers/filter/as-user-field-meta';
import { filterableFieldType } from 'module/helpers/filter/type-transformers';
import { FieldType } from 'module/types/filter-field/field/field';
import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { camelCase } from 'lodash';
import { useGetAllEmailFieldsQuery } from 'queries/fields';
import { useGetAllUsersQuery } from 'queries/member';
import { useMemo } from 'react';

export const useEmailFieldsAsFilterableFields = () => {
  const { data: emailFields, isLoading } = useGetAllEmailFieldsQuery();
  const { data: allUsers, isLoading: isUserLoading } = useGetAllUsersQuery();
  const userMeta = useMemo(() => {
    return asUserMetaData(allUsers ?? []);
  }, [allUsers]);

  return useMemo(
    () => ({
      loading: isLoading || isUserLoading,
      fields: (
        (emailFields ?? [])
          .map((field) => ({
            ...field,
            fieldName: camelCase(field.fieldName),
            type: filterableFieldType(field),
            sourceType: SourceType.Email,
          }))
          .map((field) =>
            [FieldType.SingleUser, FieldType.MultiUser].includes(field.type)
              ? { ...field, metaData: userMeta }
              : field,
          ) as FilterableField[]
      ).filter((field) => field.isEnabled),
    }),
    [isLoading, isUserLoading, emailFields, userMeta],
  );
};
